import {useEffect, useRef} from 'react'
import type {GenericContent} from '../../../../../../brand/lib/types/contentful'
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {Image} from '@primer/react-brand'

import Mona from './_assets/cat.webp'
import Copilot from './_assets/copilot.webp'
import Duck from './_assets/duck.webp'
import Butterfly from './Butterfly/Butterfly'

import Styles from './Visual.module.css'

type Props = {
  content: GenericContent
}

export function Visual(props: Props) {
  const {content} = props

  const {text} = content.fields
  const ariaDescription = text ? documentToPlainTextString(text) : ''

  const visualRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!visualRef.current) return
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (reduceMotion) {
      visualRef.current.classList.add(Styles.NoAnimation)
      return
    } else {
      const observer = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (visualRef.current) {
                visualRef.current.classList.add(Styles.Animation)
                observer.unobserve(visualRef.current)
              }
            }
          }
        },
        {threshold: 0.5},
      )

      observer.observe(visualRef.current)
    }
  }, [])
  return (
    <div className={Styles.Visual} ref={visualRef}>
      <div className={Styles.VisualWrapper}>
        <Image className={Styles.Mona} src={Mona} alt="" loading="lazy" />
        <Image className={Styles.Copilot} src={Copilot} alt="" loading="lazy" />
        <Image className={Styles.Duck} src={Duck} alt="" loading="lazy" />
        <Butterfly />
      </div>
      <div className="sr-only">{ariaDescription}</div>
    </div>
  )
}
